import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const MPButIcon = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        id="But"
        data-name="But"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 132.51 106.01"
        strokeWidth={0}
        fill="currentColor"
      >
        <title>But</title>
        <g id="g841">
          <path
            id="path22355"
            fill="#ed1c24"
            d="m119.26,0H13.25v106.01h106.01V0Z"
          />
          <g id="g22586">
            <path
              id="path22367"
              fill="#fff"
              d="m39.28,54.89h-3.34v7.18h3.44c2.28,0,3.24-1.51,3.24-3.75,0-1.82-.56-3.43-3.34-3.43m-3.34-11.87v6.24h3.55c2.15,0,2.9-1.55,2.9-3.4s-.9-2.83-3-2.83h-3.45Zm4.52,23.99h-12.35v-28.93h13.48c4.41,0,7.98,1.79,7.98,7.1,0,2.62-1.13,5.35-4.49,6.39,2.97.75,5.58,3.03,5.58,6.52,0,5.27-3.27,8.92-10.21,8.92"
            />
            <path
              id="path22371"
              fill="#fff"
              d="m105.65,44.59h-7.15v22.3h-7.99v-22.3h-7.15v-6.04h22.3v6.04Z"
            />
            <path
              id="path22375"
              fill="#fff"
              d="m70.95,38.4v19.37c0,2.61-.81,4.19-3.59,4.19s-3.59-1.57-3.59-4.19v-19.37h-7.95v19.58c0,3.8.35,4.49,1.5,6.04,1.86,2.33,5.18,3.21,10.04,3.21s8.18-.88,10.03-3.21c1.15-1.55,1.5-2.25,1.5-6.04v-19.58h-7.95Z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default MPButIcon;
